const addUtmParamsToDispensaryWebsite = (website: string) =>
  website
    ? website +
      "?utm_source=leafly.com&utm_medium=referral&utm_campaign=visit-website-link"
    : null;

export default addUtmParamsToDispensaryWebsite;
